(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__vesselResourceCarouselFix) return;

  window.__vesselResourceCarouselFix = {
    controllers: new WeakMap()
  };

  const manager = window.__vesselResourceCarouselFix;

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function getCarousels(root) {
    if (!root) return [];
    const carousels = [];
    if (root instanceof Element && root.matches('[data-resource-carousel]')) {
      carousels.push(root);
    }
    if (root.querySelectorAll) {
      carousels.push(...root.querySelectorAll('[data-resource-carousel]'));
    }
    return [...new Set(carousels)];
  }

  function restoreSlides(carousel) {
    const scroller = carousel.querySelector('slideshow-slides');
    if (!scroller) return;

    scroller.style.removeProperty('display');

    scroller.querySelectorAll('slideshow-slide.resource-list__slide').forEach((slide, index) => {
      slide.hidden = false;
      slide.removeAttribute('hidden');
      slide.removeAttribute('inert');
      slide.removeAttribute('aria-hidden');
      slide.style.removeProperty('display');
      slide.style.removeProperty('visibility');
      slide.style.removeProperty('opacity');
      slide.style.removeProperty('content-visibility');

      if (index === 0) {
        slide.setAttribute('aria-current', 'true');
      } else {
        slide.removeAttribute('aria-current');
      }
    });
  }

  function resetScroll(carousel) {
    const scroller = carousel.querySelector('slideshow-slides');
    if (!scroller) return;

    const previousBehavior = scroller.style.scrollBehavior;
    scroller.style.scrollBehavior = 'auto';
    scroller.scrollLeft = 0;
    scroller.scrollTop = 0;

    requestAnimationFrame(() => {
      if (!scroller.isConnected) return;
      scroller.scrollLeft = 0;
      requestAnimationFrame(() => {
        if (!scroller.isConnected) return;
        scroller.scrollLeft = 0;
        scroller.style.scrollBehavior = previousBehavior;
      });
    });
  }

  function updateArrowPosition(carousel) {
    if (!isDesktop()) return;

    const firstSlide = carousel.querySelector('slideshow-slide.resource-list__slide');
    if (!firstSlide) return;

    const image = firstSlide.querySelector(
      '.product-card-gallery img, .product-card__media img, .card-gallery img, img'
    );
    if (!image) return;

    const imageRect = image.getBoundingClientRect();
    const carouselRect = carousel.getBoundingClientRect();
    if (!imageRect.width || !imageRect.height) return;

    const center = imageRect.top - carouselRect.top + imageRect.height / 2;
    carousel.style.setProperty('--resource-carousel-arrow-center', `${center}px`);
  }

  function updateArrows(carousel) {
    const scroller = carousel.querySelector('slideshow-slides');
    const previousButton = carousel.querySelector('[data-resource-carousel-previous]');
    const nextButton = carousel.querySelector('[data-resource-carousel-next]');

    if (!scroller || !previousButton || !nextButton) return;

    if (!isDesktop()) {
      previousButton.classList.add('is-hidden');
      nextButton.classList.add('is-hidden');
      return;
    }

    const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);

    if (maxScroll <= 4) {
      previousButton.classList.add('is-hidden');
      nextButton.classList.add('is-hidden');
      return;
    }

    previousButton.classList.toggle('is-hidden', scroller.scrollLeft <= 4);
    nextButton.classList.toggle('is-hidden', scroller.scrollLeft >= maxScroll - 4);
  }

  function getScrollAmount(carousel) {
    const scroller = carousel.querySelector('slideshow-slides');
    const firstSlide = scroller?.querySelector('slideshow-slide.resource-list__slide');

    if (!scroller) return 0;
    if (!firstSlide) return scroller.clientWidth;

    const slideWidth = firstSlide.getBoundingClientRect().width;
    const computedStyle = window.getComputedStyle(scroller);
    const gap = parseFloat(computedStyle.columnGap || computedStyle.gap) || 0;
    const columns = parseInt(carousel.dataset.columnCount || '4', 10) || 1;

    return (slideWidth + gap) * Math.max(columns, 1);
  }

  function refreshCarousel(carousel, reset = false) {
    if (!carousel || !carousel.isConnected) return;

    restoreSlides(carousel);
    if (reset) resetScroll(carousel);
    updateArrowPosition(carousel);
    updateArrows(carousel);
  }

  function runDelayedRefresh(carousel, reset = false) {
    // Perf: antes eram 7 execuções (0, 30, 80, 160, 300, 600, 1000 ms)
    [0, 300, 1000].forEach((delay) => {
      window.setTimeout(() => {
        refreshCarousel(carousel, reset);
      }, delay);
    });
  }

  function destroyCarousel(carousel) {
    const controller = manager.controllers.get(carousel);
    if (!controller) return;
    controller.destroy();
    manager.controllers.delete(carousel);
  }

  function initializeCarousel(carousel, reset = true) {
    if (!(carousel instanceof HTMLElement) || !carousel.isConnected) return;

    destroyCarousel(carousel);

    const scroller = carousel.querySelector('slideshow-slides');
    if (!scroller) return;

    const previousButton = carousel.querySelector('[data-resource-carousel-previous]');
    const nextButton = carousel.querySelector('[data-resource-carousel-next]');

    let destroyed = false;
    let scrollFrame = null;
    let resizeFrame = null;
    let mutationFrame = null;
    let restoring = false;

    const cleanup = [];

    function addListener(target, eventName, listener, options) {
      if (!target) return;
      target.addEventListener(eventName, listener, options);
      cleanup.push(() => {
        target.removeEventListener(eventName, listener, options);
      });
    }

    function handlePrevious(event) {
      event.preventDefault();
      scroller.scrollBy({ left: -getScrollAmount(carousel), behavior: 'smooth' });
    }

    function handleNext(event) {
      event.preventDefault();
      scroller.scrollBy({ left: getScrollAmount(carousel), behavior: 'smooth' });
    }

    function handleScroll() {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        updateArrows(carousel);
      });
    }

    function handleResize() {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        refreshCarousel(carousel, false);
      });
    }

    addListener(previousButton, 'click', handlePrevious);
    addListener(nextButton, 'click', handleNext);
    addListener(scroller, 'scroll', handleScroll, { passive: true });
    addListener(window, 'resize', handleResize, { passive: true });

    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });
    resizeObserver.observe(carousel);
    resizeObserver.observe(scroller);

    const stateObserver = new MutationObserver((mutations) => {
      if (destroyed || restoring) return;

      const needsRestore = mutations.some((mutation) => {
        if (mutation.type === 'childList') return true;
        return ['hidden', 'aria-hidden', 'inert'].includes(mutation.attributeName);
      });

      if (!needsRestore) return;

      cancelAnimationFrame(mutationFrame);
      mutationFrame = requestAnimationFrame(() => {
        if (destroyed) return;
        restoring = true;
        restoreSlides(carousel);
        updateArrowPosition(carousel);
        updateArrows(carousel);
        requestAnimationFrame(() => {
          restoring = false;
        });
      });
    });

    stateObserver.observe(scroller, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden', 'aria-hidden', 'inert']
    });

    carousel.querySelectorAll('img').forEach((image) => {
      if (image.complete) return;
      const handleLoad = () => {
        refreshCarousel(carousel, false);
      };
      image.addEventListener('load', handleLoad, { once: true });
      cleanup.push(() => {
        image.removeEventListener('load', handleLoad);
      });
    });

    manager.controllers.set(carousel, {
      destroy() {
        if (destroyed) return;
        destroyed = true;
        cancelAnimationFrame(scrollFrame);
        cancelAnimationFrame(resizeFrame);
        cancelAnimationFrame(mutationFrame);
        resizeObserver.disconnect();
        stateObserver.disconnect();
        cleanup.forEach((callback) => {
          try {
            callback();
          } catch (_) {}
        });
      }
    });

    carousel.setAttribute('data-resource-carousel-ready', 'true');
    runDelayedRefresh(carousel, reset);
  }

  function initializeWithin(root, reset = true) {
    getCarousels(root).forEach((carousel) => {
      initializeCarousel(carousel, reset);
    });
  }

  manager.initializeWithin = initializeWithin;

  // Carregamento normal da página (uma única inicialização para todas as vitrines)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document, false), { once: true });
  } else {
    initializeWithin(document, false);
  }

  // Atualização de configuração no editor
  document.addEventListener('shopify:section:load', (event) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initializeWithin(event.target, true);
      });
    });
  });

  document.addEventListener('shopify:section:select', (event) => {
    initializeWithin(event.target, false);
  });

  // Alguns temas fazem morph do conteúdo sem disparar section:load de maneira previsível.
  if (window.Shopify?.designMode) {
    let editorTimer = null;

    const editorObserver = new MutationObserver((mutations) => {
      const sections = new Set();

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          const section = node.matches('.shopify-section') ? node : node.closest('.shopify-section');
          if (node.matches('[data-resource-carousel]') || node.querySelector?.('[data-resource-carousel]')) {
            sections.add(section || node);
          }
        });
      });

      if (!sections.size) return;

      window.clearTimeout(editorTimer);
      editorTimer = window.setTimeout(() => {
        sections.forEach((section) => {
          initializeWithin(section, true);
        });
      }, 60);
    });

    editorObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slideshow"] && !Shopify.designMode) return;
  try {
    (function() {
    function syncSlideAccessibility(slideshow) {
      if (!slideshow) return;

      const slides = slideshow.querySelectorAll('slideshow-slide');

      slides.forEach((slide) => {
        const isHidden = slide.getAttribute('aria-hidden') === 'true';

        if (isHidden) {
          slide.setAttribute('inert', '');
        } else {
          slide.removeAttribute('inert');
        }
      });
    }

    function initSlideshowAccessibility(root) {
      if (!root || root.dataset.a11ySlidesReady === 'true') return;
      root.dataset.a11ySlidesReady = 'true';

      syncSlideAccessibility(root);

      const observer = new MutationObserver((mutations) => {
        let shouldSync = false;

        for (const mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'aria-hidden' &&
            mutation.target.tagName &&
            mutation.target.tagName.toLowerCase() === 'slideshow-slide'
          ) {
            shouldSync = true;
            break;
          }
        }

        if (shouldSync) {
          syncSlideAccessibility(root);
        }
      });

      observer.observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    function bootSlideshowsAccessibility() {
      document.querySelectorAll('slideshow-component').forEach(initSlideshowAccessibility);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootSlideshowsAccessibility, { once: true });
    } else {
      bootSlideshowsAccessibility();
    }

    document.addEventListener('shopify:section:load', bootSlideshowsAccessibility);
  })();
  } catch(e) { console.error(e); }
})();

})();
